
    <!-- <app-header [title]="'my-profile' | translate"></app-header> -->
    <app-generic-header
            [title]="'my-profile' | translate"
            [divider]="false"
            [searcher]="false"
            >
    </app-generic-header>
        <div class="cosentino-tab">
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.currentTab == 'PROFILE' }" (click)="setCurrentTab('PROFILE')" *ngIf="userInfo.accountType && ['RETAIL','FABRICATOR','INSTALLER'].includes(userInfo.accountType)">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_profile.user' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.currentTab == 'COMPANY' }" (click)="setCurrentTab('COMPANY')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_profile.company' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.currentTab == 'EMPLOYEES' }" (click)="setCurrentTab('EMPLOYEES')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_profile.employees' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.currentTab == 'SHOPS' }" *ngIf="isRetailAccount && hasChildAccounts === true" (click)="setCurrentTab('SHOPS')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_profile.assoc_shops_myprofile_menu' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.currentTab == 'OPPORTUNITIES' }" *ngIf="(isActiveLeadsB2C || isTemporallyDisabledOnLeads) && ['RETAIL','FABRICATOR'].includes(userInfo.accountType ?? '')" (click)="setCurrentTab('OPPORTUNITIES')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_profile.opportunities' | translate }}</span>
                </div>
            </div>
        </a>
    </div>
   <div class="p-6">

    <app-user  *ngIf="currentTab === 'PROFILE'"></app-user>

    <app-company *ngIf="currentTab === 'COMPANY'"></app-company>

    <app-employees *ngIf="currentTab === 'EMPLOYEES'"></app-employees>

    <app-associate-shops *ngIf="currentTab === 'SHOPS'"></app-associate-shops>

    <app-opportunities *ngIf="currentTab === 'OPPORTUNITIES'"></app-opportunities>  
</div>
